var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{},[_vm._v("\n    The page timed out while loading. Are you sure you're still connected to\n    the Internet?\n  ")])])}]

export { render, staticRenderFns }